import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface CouponSliceType {
  amount?: number | undefined;
}

function emptyCouponSlice(): CouponSliceType {
  return {
    amount: undefined,
  };
}

function initialState(): CouponSliceType {
  return emptyCouponSlice();
}

export const couponSlice = createSlice({
  name: "coupon",
  initialState: initialState(),
  reducers: {
    storeCoupon(
      state,
      action: PayloadAction<{
        amount: number | undefined;
      }>,
    ) {
      state.amount = action.payload.amount;
    },
  },
});

export const { storeCoupon } = couponSlice.actions;
